import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('batterySerialNumberField');

    return {
        BATTERY_SERIAL_NUMBER_FIELD_LABEL: t('batterySerialNumberFieldLabel')
    };
};

export default useTranslation;
